import React from 'react';

const Dialog = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop with fade animation */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity animate-fade-in"
        onClick={onClose}
      />

      {/* Dialog positioning */}
      <div className="flex min-h-screen items-end sm:items-center justify-center p-0 sm:p-4">
        {/* Dialog content with slide animation */}
        <div 
          className="relative w-full max-w-2xl bg-white rounded-t-xl sm:rounded-lg shadow-xl animate-slide-up max-h-[95vh] sm:max-h-[85vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Dialog; 